/*
 * Copyright (c) 2023 Bolmate B.V.
 */

let csrf: string | null = null;

export function setCSRF(token: string) {
    csrf = token;
}

export function getCSRF(): string | null {
    return csrf;
}

const appLocalStorage: Record<string, any> = {};

export const saveToLocal = (key: string, value: string) => {
    if (!window.localStorage)
        return;
    window.localStorage.setItem(key, value);
}

export const getFromLocal = (key: string): string | null => {
    if (!window.localStorage) return null;
    return window.localStorage.getItem(key);
}

export const deleteFromLocal = (key: string) => {
    if (!window.localStorage) return;
    window.localStorage.removeItem(key);
}

export const saveToAppLocal = (key: string, value: any) => {
    appLocalStorage[key] = value;
};

export const getFromAppLocal = (key: string): any => {
    return appLocalStorage[key];
};

export const deleteFromAppLocal = (key: string) => {
    delete appLocalStorage[key];
};

export function logAppLocal() {
    return appLocalStorage;
}

export const IGNORE_BOL_ISSUE_KEY = 'ignore_bol_issue';
export const CONFETTI_SHOWN_KEY = 'confetti_shown';